import WillEditorInput from "../components/input";
import STKAnimated from "@/components/common/animated";
import { viewHeadings } from "../will-editor";
import { PageContentField } from "@/providers/content-provider";

const WillEditorView6 = () => {

    return(
        <STKAnimated key={6} type="down-to-up">
            <h5>{viewHeadings[5]}</h5>
            <PageContentField section={'view-6'} index={0} />  
            <div className="mt-4">
                <WillEditorInput textarea rows={10} label="Kirjoita tähän vapaasti muuta huomioitavaa" name="otherNotes"></WillEditorInput> 
            </div> 

        </STKAnimated>
    );

}

export default WillEditorView6;